import { ApiPathsService } from 'src/app/api-paths.service';
import { ToastrService } from 'ngx-toastr';
import { FileStoreService } from './../../../../app/shared/_services/file-store.service';
import { Subscription } from 'rxjs';
import { PersonaleStoreService } from '../../../Admin/_service/personale-store.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Persona } from '../../../Admin/models/persona';
import { AuthenticationService } from 'src/app/Login/_services/authentication.service';
import { ActivatedRoute, Router } from '@angular/router';
import {Ordini} from '../../../../environments/Modules/Marketplace/I miei Ordini';
import {CampoAggiuntivo} from "../../../shared/models/campo-aggiuntivo";
import {getOrdineDefaultSaveCliente} from '../../../../environments/Modules/Marketplace/Admin/Utenti';
import { idsToBase64 } from '../../../../environments/Modules/Marketplace/ProductUtility';

@Component({
  selector: 'app-profilo',
  templateUrl: './profilo-market.component.html',
  styleUrls: ['./profilo-market.component.css']
})
export class ProfiloMarketComponent implements OnInit, OnDestroy {

  subscriptions: Subscription = new Subscription();

  currentUser: any = null;
  cliente: any = null;
  dati: any = null;
  tabAttivo: 'dati' | 'ordini' = 'dati';
  selectedFile: File | null = null;
  allegatoNome = '';
  ordiniCrud = Ordini('CR');
  ordiniCrudField = CampoAggiuntivo.Crud(
    "",
    Ordini('CR'),
    {
      prevDivClass: 'col-lg-12',
      class: 'col-12'
    }
  );
  ordini: any[] = [];
  loadingOrdini = false;
  loading = false;
  editMode = false;

  campiAggiuntivi: CampoAggiuntivo[] = [
    CampoAggiuntivo.Crud("Ordini", Ordini('CR'), {
      prevDivClass: 'col-lg-12',
      class: 'col-12'
    })
  ];

  constructor(
    private authSvc: AuthenticationService,
    private api: ApiPathsService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.subscriptions.add(
      this.authSvc.currentUser.subscribe((user: any) => {
        if (!user) return;

        this.currentUser = user;
        this.getProfiloCliente();
      })
    );
  }

  getProfiloCliente() {
    this.loading = true;

    this.api.ClassicPost('/anagrafica/profilo/cliente', this.currentUser).subscribe({
      next: async (res: any) => {
        if (res.id_immagine) {
          const immagini = await idsToBase64(
            [res.id_immagine],
            this.api.getBaseAPI()
          );
          res.fotoProfilo = immagini[0];
        }
        this.cliente = res;
        this.dati = this.mapCliente(res);
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        console.error('Errore caricamento profilo cliente');
      }
    });
  }

  mapCliente(c: any) {
    const referente = c?.referenti?.find((x: any) => x.principale) || c?.referenti?.[0] || null;
    const fotoProfilo = (c?.files || []).find(
      (file: any) => file.tipo === 'foto_profilo'
    );
    return {
      id: c?.id,

      nomeNegozio: c?.soprannome || '-',
      membroDal: c?.createdAt ? new Date(c.createdAt).getFullYear() : '',
      //acquisti: 38,

      ruoloLabel: this.getRuoloLabel(c),
      statoLabel: c?.statoObject?.label || '',

      ragioneSociale: c?.fullName || '',
      nomeReferente: referente?.nome || '',
      cognomeReferente: referente?.cognome || '',
      email: c?.email || '',
      telefono: c?.telefono || '',
      lingua: 'Italiano',
      fotoProfiloUrl: c.fotoProfilo || null,
      id_immagine: c?.id_immagine || null,
      indirizzo: c?.indirizzo || '',
      citta: c?.citta || '',
      cap: c?.cap || '',
      paese: c?.nazione || 'Italia',

      partitaIva: c?.piva || '',
      codiceFiscale: c?.cf || '',
      pec: c?.pec || '',
      codiceSdi: c?.codice_univoco || '',
      //intestazioneFatturazione: this.getIntestazioneFatturazione(c),

      stato: c?.stato,
      createdAt: c?.createdAt,

      isAcquirente: c?.stato == 89 || c?.stato === 90,
      isVenditore: c?.stato === 91,
      isRichiestaVenditore: c?.stato === 90,
      isVenditoreSospeso: c?.stato === 92,

      canSell: c?.canSell === true,
    };
  }

  onFotoProfiloSelected(event: any) {

    const file = event.target.files?.[0];

    if (!file) {
      return;
    }

    if (!file.type.startsWith('image/')) {
      this.toastr.warning('Seleziona un file immagine valido');
      return;
    }

    this.selectedFile = file;
    this.allegatoNome = file.name;

    this.uploadFotoProfilo();

    event.target.value = '';

  }

  uploadFotoProfilo() {

    if (!this.selectedFile) {
      return;
    }

    const idCliente = this.dati?.id || this.cliente?.id;

    if (!idCliente) {
      this.toastr.error('Id cliente non trovato');
      return;
    }

    const idImmaginePrecedente =
      this.dati?.id_immagine || this.cliente?.id_immagine;

    const doUpload = () => {

      const formData = new FormData();

      formData.append('id', idCliente.toString());
      formData.append('descrizione', '');
      formData.append('tipo', 'foto_profilo');
      formData.append('allegato', this.selectedFile as File, this.allegatoNome);

      this.api.MultipartSendRequest(
        formData,
        this.api.getBaseAPI() + "/anagrafica/clienti/file",
        false,
        0,
        () => {

          this.selectedFile = null;
          this.allegatoNome = '';

          this.toastr.success('Foto profilo aggiornata');

          setTimeout(() => {
            this.getProfiloCliente();
          }, 300);

        }
      );

    };

    if (idImmaginePrecedente) {

      this.api.ClassicPost(
        '/file/delete',
        {
          id: idImmaginePrecedente
        }
      ).subscribe({
        next: () => {
          doUpload();
        },
        error: () => {
          this.toastr.error('Errore eliminazione vecchia foto profilo');
        }
      });

      return;
    }

    doUpload();

  }
  deleteFotoProfilo() {

    const idImmagine = this.dati?.id_immagine || this.cliente?.id_immagine;

    if (!idImmagine) {
      this.toastr.warning('Nessuna foto profilo da eliminare');
      return;
    }

    const conferma = confirm(
      'Sei sicuro di voler eliminare la foto profilo?'
    );

    if (!conferma) {
      return;
    }

    this.api.ClassicPost(
      '/file/delete',
      {
        id: idImmagine
      }
    ).subscribe({
      next: () => {

        this.toastr.success('Foto profilo eliminata');

        if (this.dati) {
          this.dati.id_immagine = null;
          this.dati.fotoProfiloUrl = null;
        }

        if (this.cliente) {
          this.cliente.id_immagine = null;
          this.cliente.fotoProfilo = null;
        }

        this.getProfiloCliente();

      },
      error: () => {
        this.toastr.error('Errore eliminazione foto profilo');
      }
    });

  }
  getRuoloLabel(c: any): string {
    const stato = c?.stato;

    if (stato == 89 || stato === 90) {
      return 'Acquirente';
    }

    if (stato === 91 || stato === 92) {
      return 'Venditore';
    }

    return '-';
  }

  richiediVenditore() {
    const codiceSdiSalvato = this.cliente?.codice_univoco;

    if (!codiceSdiSalvato || codiceSdiSalvato.trim() === '') {
      this.toastr.warning('Salva prima il codice SDI nei dati business');
      return;
    }

    if (this.editMode) {
      this.toastr.warning('Salva prima le modifiche ai dati');
      return;
    }
    if (!this.dati?.codiceSdi || this.dati.codiceSdi.trim() === '') {
      this.toastr.warning('Inserire codice SDI');
      return;
    }

    const payload = {
      ...this.cliente,
      codice_univoco: this.dati.codiceSdi,
      stato: 90
    };

    this.api.ClassicPost(
      '/anagrafica/profilo/cliente/update',
      payload
    ).subscribe({
      next: () => {
        this.toastr.success('Richiesta venditore inviata con successo');
        this.getProfiloCliente();
      },
      error: () =>{
        this.toastr.error('Errore richiesta venditore');
      }
    });
  }

  getInitials(): string {
    if (!this.dati?.nomeNegozio) return '-';

    return this.dati.nomeNegozio
      .split(' ')
      .map((x: string) => x[0])
      .join('')
      .substring(0, 2)
      .toUpperCase();
  }

  cambiaTab(tab: 'dati' | 'ordini'){
    this.tabAttivo = tab;

  }

  editClick() {
    this.editMode = true;
  }

  cancelEdit() {
    this.dati = this.mapCliente(this.cliente);
    this.editMode = false;
  }

  saveClick() {
    const payload = {
      ...this.cliente,
      
      soprannome: this.dati.nomeNegozio,
      fullName: this.dati.ragioneSociale,
      email: this.dati.email,
      telefono: this.dati.telefono,
      indirizzo: this.dati.indirizzo,
      citta: this.dati.citta,
      cap: this.dati.cap,
      nazione: this.dati.paese,
      piva: this.dati.partitaIva,
      cf: this.dati.codiceFiscale,
      pec: this.dati.pec,
      codice_univoco: this.dati.codiceSdi
    };

    this.api.ClassicPost('/anagrafica/profilo/cliente/update', payload).subscribe({
      next: (res: any) => {
        this.getProfiloCliente();
        this.editMode = false;
      },
      error: () => {
        console.error('Errore salvataggio profilo cliente');
      }
    });
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
